export default {
  namespaced: true,
  state: {
    corners: []
  },
  getters: {
    all: state => state.corners,
    getByHallId: state => hallId => {
      return _.filter(state.corners, ["hall_id", hallId])
    }
  },
  mutations: {
    setCorners(state, corners) {
      state.corners = corners
    }
  },
  actions: {
    /**
     * コーナーの取得
     * @param {object} context
     * @param {string} slug
     * @returns {Promise<void>}
     */
    async getCorners(context, slug) {
      await this._vm.$axios
        .get(`events/${slug}/corners`)
        .then(response => {
          context.commit("setCorners", response.data.corners)
        })
        .catch(error => {
          console.error(error)
        })
    }
  }
}
